import { RootState } from 'app/state/store'
import { SchemaStatus, WorkflowLoadMode } from '../enums'

export const workflowSelectors = {
  getWorkflow: (state: RootState) => state.workflows?.workflow || undefined,

  getSelectedNode: (state: RootState) =>
    state.workflows?.workflow?.config.nodes.find((n) => n.id === state.workflows.selectedId),

  getNodes: (state: RootState) => state.workflows?.workflow?.config.nodes,

  getEdges: (state: RootState) => state.workflows?.workflow?.config.edges,

  getNodeSchemaStatus: (nodeId: string) => (state: RootState) => state.workflows?.schemas[nodeId]?.status,

  getIsNodeSchemaLoading: (nodeId: string) => (state: RootState) =>
    workflowSelectors.getNodeSchemaStatus(nodeId)(state) === SchemaStatus.Pending,

  getNodeSchemas: (nodeId: string) => (state: RootState) => state.workflows?.schemas?.[nodeId]?.data || [],

  getNodeSchemaHasError: (nodeId: string) => (state: RootState) =>
    workflowSelectors.getNodeSchemaStatus(nodeId)(state) === SchemaStatus.Failed,

  getNodeSchemaError: (nodeId: string) => (state: RootState) => state.workflows?.schemas[nodeId]?.error,

  getComponents: (state: RootState) => state.workflows.toolbox.components,

  getComponentByName: (name: string) => (state: RootState) => state.workflows.toolbox.components[name],

  isEditorMode: (state: RootState) => state.workflows.loadMode === WorkflowLoadMode.Editor,

  isViewerMode: (state: RootState) => state.workflows.loadMode === WorkflowLoadMode.Viewer
}
